module.exports = __webpack_public_path__ + "static/certificado-20f2bb72f51651929e8ae8821facdd94.svg";